import axios from 'axios';
import { config } from "../../config"

const d_protocol = process.env.REACT_APP_DAILYPROFIT_BACKEND_PROTOCOL;
const d_url = process.env.REACT_APP_DAILYPROFIT_BACKEND_HOST;
const d_port = process.env.REACT_APP_DAILYPROFIT_BACKEND_PORT;
const dailyprofitURL = `${d_protocol}${d_url}${d_port}`


const getAmountFromQuest = (questId) =>{
    return new Promise((resolve, reject)=>{
        axios.get(`${config.DAILYPROFIT_BACKEND_URL}/quests/getMyQuest?questId=${questId}`)
        .then(async (res)=>{
            if (res?.data?.quest?._id) {
                return resolve(res?.data);
            }

            const googleResponse = await axios.get(`${config.DAILYPROFIT_BACKEND_URL}/google/getGoogleQuest?questId=${questId}`).catch(() => false);

            if (googleResponse?.data?.data?._id) {
                return resolve({
                    quest: googleResponse.data.data
                });
            }

            resolve(false);
        })
        .catch(async ()=>{
            const googleResponse = await axios.get(`${config.DAILYPROFIT_BACKEND_URL}/google/getGoogleQuest?questId=${questId}`).catch(() => false);

            if (googleResponse?.data?.data?._id) {
                return resolve({
                    quest: googleResponse.data.data
                });
            }

            resolve(false);
        })

    })
}

const getBoostAmountFromQuest = (questId) =>{
    return new Promise((resolve, reject)=>{
        axios.get(`${config.DAILYPROFIT_BACKEND_URL}/quests/getBoostAmountFromQuest?questId=${questId}`)
        .then(res=>{
            resolve(res?.data)
        })
        .catch(()=>{
            resolve(false);
        })
    })
}

const getInfoFromQuest = (subId) =>{
    return new Promise((resolve, reject)=>{
        axios.get(`${config.DAILYPROFIT_BACKEND_URL}/quests/getMyQuest?subId=${subId}`)
        .then(res=>{
            resolve(res?.data)
        })
        .catch(()=>{
            resolve(false);
        })

    })
}

const getQuestsWithSubIds = (userId) =>{
    return new Promise((resolve, reject)=>{
        axios.get(`${config.DAILYPROFIT_BACKEND_URL}/quests/getMyQuestsWithSubs?userId=${userId}`)
        .then(res=>{
            resolve(res)
        })
        .catch(()=>{
            resolve(false);
        })

    })
}


const getBrandBillingCustomer = (questId) => {
    return axios.get(config.DAILYPROFIT_BACKEND_URL + '/quests/getBrandBillingCustomer?questId=' + encodeURIComponent(questId)).then((res) => res?.data).catch(() => false);
}

const syncCheckoutBrandCustomer = (data) => {
    return axios.post(config.DAILYPROFIT_BACKEND_URL + '/quests/syncCheckoutBrandCustomer', data).then((res) => res?.data).catch(() => false);
}

const getBrandAssociation = (questId) => {
    return axios.get(`${config.DAILYPROFIT_BACKEND_URL}/quests/getBrandAssociation?questId=${encodeURIComponent(questId)}`).then((res) => res?.data).catch(() => false);
}

export {
    getAmountFromQuest,
    getInfoFromQuest,
    getQuestsWithSubIds,
    getBoostAmountFromQuest,
    getBrandAssociation,
    getBrandBillingCustomer,
    syncCheckoutBrandCustomer
};
